import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import UserLevelPoints from '@/components/UserLevelPoints.vue'
  import useIcons from '@/composables/useIcons'
  import { UserModule } from '@/store/modules/user'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useEditor from '@/composables/useEditor'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { vOnClickOutside } from '@vueuse/components'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserArea',
  props: {
    createSpaceForSearchInput: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

  const route = useRoute()
  const { defaultUserIcon } = useIcons()
  const { isLargeDesktop, isDesktopDevice } = useBreakpoint()
  const { inEditorMode } = useEditor(route)
  const { isSachkundeCompany, isKnowledgeCheckCompany } = useCommonMixin()

  const openUserDropdown = ref(false)
  const timerId = ref(0)

  const hasValidUser = computed((): boolean => {
    return UserModule.hasValidUser
  })

  const hasMultipleCompanies = computed(() => {
    return UserModule.companies.length > 1
  })

  const initials = computed((): string => {
    return UserModule.initials || ''
  })

  const allowDarkMode = computed(() => {
    return UserModule.allowDarkMode
  })

  const showUserLevelPoints = computed(() => {
    // TODO we do this for sachkungegurus because we don't have many nav items
    return (isSachkundeCompany.value ? isDesktopDevice.value : isLargeDesktop.value) && hasValidUser.value
  })

  const isInternalCompanyAdmin = computed(() => {
    const isInternalUser = UserModule.email?.includes('ketchup.academy')
    return UserModule.isCompanyAdmin && isInternalUser
  })

  const toggleUserDropdown = () => {
    if (timerId.value) window.clearTimeout(timerId.value)
    timerId.value = window.setTimeout(() => {
      openUserDropdown.value = !openUserDropdown.value
    }, 50)
  }

return { __sfc: true,route, defaultUserIcon, isLargeDesktop, isDesktopDevice, inEditorMode, isSachkundeCompany, isKnowledgeCheckCompany, openUserDropdown, timerId, hasValidUser, hasMultipleCompanies, initials, allowDarkMode, showUserLevelPoints, isInternalCompanyAdmin, toggleUserDropdown, computed, ref, SVGRenderer, UserLevelPoints, useIcons, UserModule, useBreakpoint, useEditor, useCommonMixin, vOnClickOutside, useRoute }
}

})